const truthyKey = (obj) => Object.keys(obj).find((key) => obj[key]);

export default truthyKey;
